<template>
<ul class="list_image" v-if="selectedCameraInfo !== null && historyList.length && isActiveListImage === true">
    <li class="clearfix">
        <div class="list_header clearfix">
            <h3><span class="snap">◆<span>静止画</span></span>{{selectedCameraInfo[1]}}</h3>
        </div>

        <!-- 履歴の静止画一覧 -->
        <div class="history_list" v-for="(historylist, historylist_key) in historyList" :key="historylist_key">
            <h4 v-if="historylist.sequence !== 0">{{historylist.hour}}:00</h4>
            <ul v-if="historylist.sequence !== 0" class="clearfix_pc">
                <li v-for="n of historylist.sequence" :key="n">
                    <a :href="historylist[n].image_url_static" target="_blank" rel="noopener noreferrer">
                        <span>{{ historylist[n].datetime | datetimeFormat }}</span>

                        <!-- サムネイル画像がS3に存在するか確認し、画像読み込み処理実行 && 画像読み込み回数を監視して、ローディングアイコンを非表示にする処理-->
                        <img v-if="historylist[n].image_url_thumbnail !== ''" :src="historylist[n].image_url_thumbnail" @load="loaded" />
                        <img v-else-if="historylist[n].image_url_thumbnail === ''" :src="historylist[n].image_url_static" @load="loaded" />
                        <img v-else :src="noImageUrl" @load="loaded" />
                    </a>
                </li>
            </ul>
        </div>

    </li>
</ul>
</template>
<script>

export default {
    name: 'HistoryImageLists',
    data(){
        return {
            // サムネイル一覧情報の配列
            formatHistoryList: {},

            //ローディング済みのサムネイルをカウントして格納
            loadedCount: 0,

            // 画像がない場合にNoImageを読み込む
            noImageUrl: require("../../assets/images/no_image.png")
        }
    },
    props:{
        // 選択したカメラ情報を格納
        selectedCameraInfo:{
            type: Array
        },

        // 履歴データを格納
        historyList:{
            type: Array
        },

        // 選択中の静止画の情報を格納
        isActiveListImage:{
            type: Boolean,
        },

        // サムネイルの合計した数値を格納
        is_thumbnailHourCount: {
            type: Number
        }
    },
    methods: {
        /**********************************************************/
        // サムネイルの読み込みが全て完了した時にローディング画面を終了
        /**********************************************************/
        loaded() {
            this.loadedCount++
            if(this.loadedCount === Object.keys(this.formatHistoryList).length) {
                this.loadedCount = 0;
                this.$emit('finished');
            }
        }
    },
    watch: {
        historyList:{
            handler() {
                /**********************************************************/
                // historyListの配列を整形
                //
                // サムネイルの合計枚数とカウント数の一致でローディング終了か
                // 否かを判断するために整形している
                /**********************************************************/
                this.formatHistoryList = {};
                for (var hour = 0; hour <= this.historyList.length - 1; hour++) {
                    if (this.historyList[hour].sequence != 0) {
                        for (var i = 1; i <= this.historyList[hour].sequence; i++) {
                            this.$set(this.formatHistoryList, hour + '_' + i, this.historyList[hour][i]);
                        }
                    }
                }
                /**********************************************************/
                // サムネイル画像が1枚も存在しない場合にロードを終了させる
                /**********************************************************/
                if(this.is_thumbnailHourCount === 0) {
                    this.$emit('finished');
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"履歴取得エラー",
                        sub_message:"保存されているデータがありません。",
                        errorFlag: true
                    });
                }
            },
            deep: true
        },
    },

    /**********************************************************/
    // サムネイルに表示される時刻をフォーマット
    /**********************************************************/
    filters: {
        datetimeFormat(unixtime) {
            var dateTime = new Date(unixtime * 1000);
            var year = dateTime.getFullYear();
            var mon = ( dateTime.getMonth() + 1 < 10 ) ? ( '0' + ( dateTime.getMonth() + 1 ) ) : dateTime.getMonth() + 1;
            var day = ( dateTime.getDate() < 10 ) ? '0' + dateTime.getDate() : dateTime.getDate();
            var hour = ( dateTime.getHours()   < 10 ) ? '0' + dateTime.getHours()   : dateTime.getHours();
            var min  = ( dateTime.getMinutes() < 10 ) ? '0' + dateTime.getMinutes() : dateTime.getMinutes();
            return year + '/' + mon + '/' + day + ' ' + hour + ':' + min;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>